const fontFamily = {
  default: 'Roboto',
  fallback: 'Arial',
  fallbackIos: '-apple-system',
  fallbackAndroid: 'Roboto',
  appleEmoji: 'Apple Color Emoji',
  windowsEmoji: 'Segoe UI Emoji',
  windowsSymbol: 'Segoe UI Symbol'
};

const fontSize = {
  base: '62.5%',
  small: '1.2rem',
  normal: '1.4rem',
  medium: '1.6rem',
  big: '1.8rem'
};

const fontWeight = {
  light: 300,
  regular: 400,
  semibold: 600,
  bold: 700,
  extrabold: 800
};

const lineHeight = {
  base: 1.5
};

export const typography = {
  fontFamily,
  fontSize,
  fontWeight,
  lineHeight
};
